document.addEventListener('DOMContentLoaded', function () {
  var LOGO_API_URL = 'https://tightlines-logo-api.pages.dev';


// popup logic

function openAccountPopup(url) {
  if (!url) return;
  var w = 480, h = 680;
  var left = Math.max(0, (window.screen.width - w) / 2);
  var top = Math.max(0, (window.screen.height - h) / 2);
  var features = 'width=' + w + ',height=' + h + ',top=' + top + ',left=' + left +
    ',resizable=yes,scrollbars=yes,status=no,toolbar=no,menubar=no,location=no';
  var popup = window.open(url, 'sc-account-popup', features);

  // Popup blocked ho jaye (rare) -> purane wale normal navigation par fallback
  if (!popup) {
    window.location.href = url;
    return;
  }

  var timer = setInterval(function () {
    if (popup.closed) {
      clearInterval(timer);
      // Popup band hone ke baad page reload — agar login ho chuka hai,
      // existing "auto email" logic khud saved logo dhoond kar
      // seedha sticker step par le jayegi.
      window.location.reload();
    }
  }, 500);
}
// popup logic

  

  var GALLERY_IMAGE_SELECTORS = [
    '.product__media img',
    '.product-single__photo img',
    '.product__photo img',
    '.product-single__media img',
    '.product-image-main img',
    'product-gallery img',
    '.product-gallery img',
    '.product-gallery__media img',
    '.product-gallery__media-item img',
    '.product-gallery__image img',
    'media-gallery img',
    '.media-gallery img',
    '[data-product-media] img',
    '[data-media-id] img',
    '.product__media-item img',
    '.product__media-list img',
    'slideshow-component img',
    '.slideshow img'
  ];

  var GALLERY_CONTAINER_HINTS = [
    'product-gallery', 'product__media', 'product-media', 'media-gallery',
    'product-single__photo', 'product__photo', 'gallery'
  ];

  var PRINT_AREA_COORDS = {
    'front':        { top: 32, left: 41, width: 50, height: 48 },
    'back':         { top: 25, left: 35, width: 50, height: 48 },
    'left sleeve':  { top: 32, left: 30, width: 26, height: 20 },
    'right sleeve': { top: 32, left: 44, width: 26, height: 20 }
  };

  var FRONT_START_POSITIONS = {
  'center':     { top: 20, left: 30 },// for login account top is working good here
  'upper-left': { top: 8, left: 8 },
  'upper-right': { top: 20, left: 50 }
  };

 
  var LOWER_POSITION_PRODUCT_HANDLES = [
    'shorts' // <-- yahan apne shorts product ka asal handle likhein
  ];

  // Front: niche + left side
  var LOWER_FRONT_POSITION = { top: 62, left: 6 };
  // Back: niche + center
  var LOWER_BACK_POSITION  = { top: 62, left: 30 };

  var FRONT_WOMENS_RIGHT_CHEST_POSITION = { top: 20, left: 28 };// for women's chest position is working good  

 
  var FRONT_MENS_LOGO_POSITION = { top: 20, left: 50 };

  function isWomensProduct() {
    var titleText = document.title || '';
    var h1 = document.querySelector('h1.product__title, h1[class*="product"], h1');
    if (h1) titleText += ' ' + (h1.textContent || '');
    return /\bwomen'?s?\b/i.test(titleText);
  }

 
  var TAG_FRONT_POSITION = {
    'left':  { top: 20, left: 50 },
    'right': { top: 20, left: 27 }
  };

  function getTagBasedFrontPosition(widget) {
    var tagsAttr = (widget.getAttribute('data-product-tags') || '').toLowerCase();
    if (!tagsAttr) return null;
    var tags = tagsAttr.split(',').map(function (t) { return t.trim(); });
    if (tags.indexOf('left') !== -1) return TAG_FRONT_POSITION['left'];
    if (tags.indexOf('right') !== -1) return TAG_FRONT_POSITION['right'];
    return null;
  }

 
  function getTagBasedTopOverride(widget) {
    var tagsAttr = (widget.getAttribute('data-product-tags') || '').toLowerCase();
    if (!tagsAttr) return null;
    var tags = tagsAttr.split(',').map(function (t) { return t.trim(); });
    for (var i = 0; i < tags.length; i++) {
      var match = tags[i].match(/^top-?(\d+(?:\.\d+)?)$/);
      if (match) return parseFloat(match[1]);
    }
    return null;
  }


  // backtop position
  // NAYA: sirf BACK sticker ke liye top-only override tag.
// Product par tag "backtop-20" (ya "backtop20") lagayein to back sticker
// ka top position 20% par set ho jayega. Front ke "top-XX" tag se
// bilkul alag/independent hai — isliye front ka koi behavior touch nahi hota.
function getTagBasedBackTopOverride(widget) {
  var tagsAttr = (widget.getAttribute('data-product-tags') || '').toLowerCase();
  if (!tagsAttr) return null;
  var tags = tagsAttr.split(',').map(function (t) { return t.trim(); });
  for (var i = 0; i < tags.length; i++) {
    var match = tags[i].match(/^backtop-?(\d+(?:\.\d+)?)$/);
    if (match) return parseFloat(match[1]);
  }
  return null;
}
  // backtop position



  // back left position
  
    // backleft position
  // NAYA: sirf BACK sticker ke liye left-only override tag.
  // Product par tag "backleft-20" (ya "backleft20") lagayein to back sticker
  // ka left position 20% par set ho jayega. Tag na ho to kuch bhi nahi hota.
  function getTagBasedBackLeftOverride(widget) {
    var tagsAttr = (widget.getAttribute('data-product-tags') || '').toLowerCase();
    if (!tagsAttr) return null;
    var tags = tagsAttr.split(',').map(function (t) { return t.trim(); });
    for (var i = 0; i < tags.length; i++) {
      var match = tags[i].match(/^backleft-?(\d+(?:\.\d+)?)$/);
      if (match) return parseFloat(match[1]);
    }
    return null;
  }
  // backleft position
  // back left position

  
  function getTagBasedLeftOverride(widget) {
    var tagsAttr = (widget.getAttribute('data-product-tags') || '').toLowerCase();
    if (!tagsAttr) return null;
    var tags = tagsAttr.split(',').map(function (t) { return t.trim(); });
    for (var i = 0; i < tags.length; i++) {
      var match = tags[i].match(/^left-?(\d+(?:\.\d+)?)$/);
      if (match) return parseFloat(match[1]);
    }
    return null;
  }

 
  function isHatProduct(widget) {
    var tagsAttr = (widget.getAttribute('data-product-tags') || '').toLowerCase();
    if (!tagsAttr) return false;
    var tags = tagsAttr.split(',').map(function (t) { return t.trim(); });
    return tags.indexOf('hat') !== -1;
  }

  var STICKER_FRONT_POSITION = { top: 25, left: 25 };

  function isStickerProduct(widget) {
    var tagsAttr = (widget.getAttribute('data-product-tags') || '').toLowerCase();
    if (!tagsAttr) return false;
    var tags = tagsAttr.split(',').map(function (t) { return t.trim(); });
    return tags.indexOf('sticker') !== -1;
  }

  // back hidden
    // NAYA: "noback" tag — is tag wale products par "Select back"
  // wala poora block hide ho jata hai. Tag na ho to kuch nahi hota.
  function isNoBackProduct(widget) {
    var tagsAttr = (widget.getAttribute('data-product-tags') || '').toLowerCase();
    if (!tagsAttr) return false;
    var tags = tagsAttr.split(',').map(function (t) { return t.trim(); });
    return tags.indexOf('noback') !== -1;
  }
  // back hidden

  // front hidden
    // NAYA: "nofront" tag — is tag wale products par "Select Front"
  // wala poora block hide ho jata hai. Tag na ho to kuch nahi hota.
  function isNoFrontProduct(widget) {
    var tagsAttr = (widget.getAttribute('data-product-tags') || '').toLowerCase();
    if (!tagsAttr) return false;
    var tags = tagsAttr.split(',').map(function (t) { return t.trim(); });
    return tags.indexOf('nofront') !== -1;
  }
  // front hidden

 
  var SINGLE_SIDE_FRONT_DEFAULT = { top: 32, left: 34 }; // center

var SINGLE_SIDE_FRONT_BY_HANDLE = {
    'custom-boat-tote-bags': { top: 52, left: 34 },
    'custom-30oz-double-wall-insulated-tumbler': { top: 35, left: 26 },
    'custom-helly-hansen-crew-visor': { top: 20, left: 34 },
    'helly-hansen-mens-crew-vest': { top: 35, left: 12 },
    'insulated-stainless-steel-mugs': { top: 45, left: 40 },
    'custom-hydrapeak-nomad-water-bottle': { top: 45, left: 40 },
    'custom-boat-burgee': { top: 32, left: 36 }  // NAYA: burgee ka boat logo upar + center
    // LEFT side chahiye to aise likhein: 'apna-product-handle': { top: 35, left: 12 }
  };

  function getSingleSideFrontPosition() {
    var path = (window.location.pathname || '').toLowerCase();
    for (var handle in SINGLE_SIDE_FRONT_BY_HANDLE) {
      if (!SINGLE_SIDE_FRONT_BY_HANDLE.hasOwnProperty(handle)) continue;
      if (path.indexOf('/products/' + handle.toLowerCase()) !== -1) {
        return SINGLE_SIDE_FRONT_BY_HANDLE[handle];
      }
    }
    return SINGLE_SIDE_FRONT_DEFAULT;
  }

  function isLowerPositionProduct() {
    var path = (window.location.pathname || '').toLowerCase();
    for (var i = 0; i < LOWER_POSITION_PRODUCT_HANDLES.length; i++) {
      var handle = (LOWER_POSITION_PRODUCT_HANDLES[i] || '').toLowerCase();
      if (!handle) continue;
      if (path.indexOf('/products/' + handle) !== -1) return true;
    }
    return false;
  }


  var UPLOAD_FRONT_UPPER_LEFT_HANDLES = [
    'shorts' // <-- yahan apne caps/shorts product(s) ka asal handle likhein
  ];

  function isUploadFrontUpperLeftProduct() {
    var path = (window.location.pathname || '').toLowerCase();
    for (var i = 0; i < UPLOAD_FRONT_UPPER_LEFT_HANDLES.length; i++) {
      var handle = (UPLOAD_FRONT_UPPER_LEFT_HANDLES[i] || '').toLowerCase();
      if (!handle) continue;
      if (path.indexOf('/products/' + handle) !== -1) return true;
    }
    return false;
  }

 
  var BACK_LABEL_AS_FRONT_HANDLES = [
    'caps' // <-- (ab use nahi hoti — automatic detection ki wajah se)
  ];

  function isBackLabelAsFrontProduct() {
    var path = (window.location.pathname || '').toLowerCase();
    for (var i = 0; i < BACK_LABEL_AS_FRONT_HANDLES.length; i++) {
      var handle = (BACK_LABEL_AS_FRONT_HANDLES[i] || '').toLowerCase();
      if (!handle) continue;
      if (path.indexOf('/products/' + handle) !== -1) return true;
    }
    return false;
  }

  function relabelBackAsFront(widget) {
    var frontBlock = widget.querySelector('[data-sc-block="front"]');
    var backBlock = widget.querySelector('[data-sc-block="back"]');
    // back block dikh hi nahi raha -> kuch mat karo
    if (!backBlock || backBlock.hidden) return;
    // front block bhi dikh raha hai -> normal (front+back) product, kuch mat karo
    if (frontBlock && !frontBlock.hidden) return;

    var els = backBlock.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      // sirf chhoti text-wali (leaf) elements — bade containers skip
      if (el.children.length > 0) continue;
      // "Back" navigation link ko haath mat lagao
      if (el.closest && el.closest('a, .sc-link-back, [class*="sc-back-"]')) continue;
      var txt = (el.textContent || '').trim();
      if (/^select\s+back$/i.test(txt)) {
        el.textContent = txt.replace(/back/i, 'Front');
      } else if (/^back$/i.test(txt)) {
        el.textContent = 'Front';
      }
    }
  }

  function getPrintAreaCoords(label) {
    return PRINT_AREA_COORDS[(label || '').toLowerCase()] || PRINT_AREA_COORDS['front'];
  }

  function isVisible(el) {
    return !!el && el.offsetParent !== null && el.offsetWidth > 20 && el.offsetHeight > 20;
  }

  function findGalleryImage(debugLabel) {
    for (var i = 0; i < GALLERY_IMAGE_SELECTORS.length; i++) {
      var el = document.querySelector(GALLERY_IMAGE_SELECTORS[i]);
      if (isVisible(el)) return el;
    }
    var allImgs = Array.prototype.slice.call(document.querySelectorAll('img'));
    var candidates = allImgs.filter(function (img) {
      if (!isVisible(img)) return false;
      var node = img;
      for (var depth = 0; depth < 6 && node; depth++) {
        var idClass = ((node.id || '') + ' ' + (node.className || '') + ' ' + (node.tagName || '')).toLowerCase();
        for (var h = 0; h < GALLERY_CONTAINER_HINTS.length; h++) {
          if (idClass.indexOf(GALLERY_CONTAINER_HINTS[h]) !== -1) return true;
        }
        node = node.parentElement;
      }
      return false;
    });
    if (candidates.length) {
      candidates.sort(function (a, b) {
        return (b.offsetWidth * b.offsetHeight) - (a.offsetWidth * a.offsetHeight);
      });
      return candidates[0];
    }
    console.warn(
      '[sticker-customizer] Gallery image nahi mili (' + (debugLabel || '') + '). ' +
      'Inspect Element se product image ka exact class/tag copy karke ' +
      'GALLERY_IMAGE_SELECTORS list mein sabse upar add karein.'
    );
    return null;
  }

  // function altMatchesLabel(altText, label) {
  //   var re = new RegExp('\\b' + label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'i');
  //   return re.test(altText || '');
  // }


     function altMatchesLabel(altText, label) {
     var alt = (altText || '').trim().toLowerCase();
     var l = (label || '').toLowerCase();

     // 1) exact match (alt="front" / alt="back")
     if (alt === l) return true;

     // 2) word match, lekin agar front aur back DONO hon (jaise product title) to reject
     var esc = l.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
     if (!new RegExp('\\b' + esc + '\\b', 'i').test(alt)) return false;

     var hasFront = /\bfront\b/i.test(alt);
     var hasBack  = /\bback\b/i.test(alt);
     if (hasFront && hasBack) return false;

     return true;
   }



  function findGalleryImageByAlt(label) {
    var candidates = document.querySelectorAll(GALLERY_IMAGE_SELECTORS.join(','));
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (isVisible(el) && altMatchesLabel(el.getAttribute('alt'), label)) return el;
    }
    var allImgs = document.querySelectorAll('img');
    for (var j = 0; j < allImgs.length; j++) {
      var img = allImgs[j];
      if (isVisible(img) && altMatchesLabel(img.getAttribute('alt'), label)) return img;
    }
    return null;
  }

  function findRealQuantityInput() {
    return document.querySelector('input[name="quantity"]');
  }

  function findAllImagesByAlt(label) {
    var scoped = document.querySelectorAll(GALLERY_IMAGE_SELECTORS.join(','));
    var matches = [];
    for (var i = 0; i < scoped.length; i++) {
      if (altMatchesLabel(scoped[i].getAttribute('alt'), label)) matches.push(scoped[i]);
    }
    if (matches.length) return matches;
    var all = document.querySelectorAll('img');
    for (var j = 0; j < all.length; j++) {
      if (altMatchesLabel(all[j].getAttribute('alt'), label)) matches.push(all[j]);
    }
    return matches;
  }

  
  function findImageByAltAnyVisibility(label) {
    var all = findAllImagesByAlt(label);
    return all.length ? all[0] : null;
  }

  var HORIZON_DOT_SELECTOR = '.slideshow-controls__dots .slideshow-control, .slideshow-controls__dots button';

  function getActiveSlideshowComponent() {
    var components = document.querySelectorAll('slideshow-component');
    for (var i = 0; i < components.length; i++) {
      if (isVisible(components[i])) return components[i];
    }
    return components.length ? components[0] : document;
  }

  function getDotButtons() {
    var scope = getActiveSlideshowComponent();
    var dots = scope.querySelectorAll(HORIZON_DOT_SELECTOR);
    if (dots.length) return dots;
    var fallbackSelectors = [
      '[role="tablist"] [role="tab"]',
      '.slider-counter__link',
      '.thumbnail-list__item button',
      '.thumbnail-list__item',
      '.product__thumb-item',
      '.product-thumbnails__item',
      '.flickity-page-dots .dot'
    ];
    for (var i = 0; i < fallbackSelectors.length; i++) {
      var found = scope.querySelectorAll(fallbackSelectors[i]);
      if (found.length) return found;
    }
    for (var j = 0; j < fallbackSelectors.length; j++) {
      var foundGlobal = document.querySelectorAll(fallbackSelectors[j]);
      if (foundGlobal.length) return foundGlobal;
    }
    return [];
  }

  function getCurrentDotIndex(dots) {
    for (var i = 0; i < dots.length; i++) {
      if (dots[i].getAttribute('aria-selected') === 'true') return i;
    }
    return -1;
  }


  function findPrevNextInButtons(buttons) {
    var prev = null, next = null;
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var label = (
        (btn.getAttribute('aria-label') || '') + ' ' +
        (btn.getAttribute('title') || '') + ' ' +
        (btn.getAttribute('name') || '') + ' ' +
        (btn.className || '')
      ).toLowerCase();
      if (!prev && (label.indexOf('previous') !== -1 || label.indexOf('prev') !== -1)) prev = btn;
      if (!next && label.indexOf('next') !== -1) next = btn;
    }
    return { prev: prev, next: next };
  }

  function getArrowButtons() {
    var scope = getActiveSlideshowComponent();

    // 1) Pehle jaisa tha: <slideshow-controls> ke andar dhoondo
    var controls = (scope && scope.querySelector ? scope.querySelector('slideshow-controls') : null)
      || document.querySelector('slideshow-controls');
    if (controls) {
      var fromControls = findPrevNextInButtons(controls.querySelectorAll('button, a[role="button"], a'));
      if (fromControls.prev || fromControls.next) return fromControls;
    }

    // 2) NAYA (FIX): kuch galleries mein arrows seedhe slideshow-component
    // ke andar hote hain (slideshow-controls tag ke bahar). Wahan dhoondo.
    if (scope && scope.querySelectorAll) {
      var fromScope = findPrevNextInButtons(scope.querySelectorAll('button, a[role="button"]'));
      if (fromScope.prev || fromScope.next) return fromScope;
    }

    // 3) Last resort: poore page mein dhoondo
    return findPrevNextInButtons(document.querySelectorAll('button, a[role="button"]'));
  }

  function findCounterTextElement(root) {
    if (!root || !root.querySelectorAll) return null;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      // sirf leaf-jaisi (thodi text wali) elements check karo, taake bade
      // containers ka poora text ikattha match na ho jaye
      if (el.children.length > 1) continue;
      var text = (el.textContent || '').trim();
      if (/^\d{1,3}\s*\/\s*\d{1,3}$/.test(text)) return el;
    }
    return null;
  }

  function getCounterCurrentIndex() {
    var scope = getActiveSlideshowComponent();

    // 1) Pehle jaisa: <slideshow-controls> ke andar text dhoondo
    var controls = (scope && scope.querySelector ? scope.querySelector('slideshow-controls') : null)
      || document.querySelector('slideshow-controls');
    if (controls) {
      var text1 = controls.textContent || '';
      var match1 = text1.match(/(\d+)\s*\/\s*(\d+)/);
      if (match1) return parseInt(match1[1], 10) - 1;
    }

    // 2) NAYA (FIX): counter kahin aur render ho raha ho (jaise seedha
    // slideshow-component ke andar, "1 / 17" jaisi chhoti element mein)
    var counterEl = findCounterTextElement(scope) || findCounterTextElement(document.body);
    if (counterEl) {
      var match2 = (counterEl.textContent || '').match(/(\d+)\s*\/\s*(\d+)/);
      if (match2) return parseInt(match2[1], 10) - 1;
    }

    return -1;
  }

  function waitForCounterChange(previousIndex, callback, pollsLeft) {
    if (typeof pollsLeft === 'undefined') pollsLeft = 20; // ~20 * 120ms = 2.4s max wait per step
    var idx = getCounterCurrentIndex();
    if (idx !== previousIndex || pollsLeft <= 0) {
      callback();
      return;
    }
    setTimeout(function () {
      waitForCounterChange(previousIndex, callback, pollsLeft - 1);
    }, 120);
  }

  function navigateByArrowsToIndex(targetIndex, callback, attemptsLeft) {
    if (typeof attemptsLeft === 'undefined') attemptsLeft = 40; // infinite-loop se bachne ke liye safety cap
    var currentIndex = getCounterCurrentIndex();
    if (currentIndex === -1) {
      console.warn('[sticker-customizer] Counter/arrow-based gallery mein current slide index maloom nahi ho saka.');
      callback();
      return;
    }
    if (currentIndex === targetIndex || attemptsLeft <= 0) {
      callback();
      return;
    }
    var arrows = getArrowButtons();
    var btnToClick = targetIndex > currentIndex ? arrows.next : arrows.prev;
    if (!btnToClick) {
      console.warn('[sticker-customizer] Slideshow ke prev/next arrow buttons nahi mile — gallery switch nahi ki ja sakti.');
      callback();
      return;
    }
    btnToClick.click();
    waitForCounterChange(currentIndex, function () {
      navigateByArrowsToIndex(targetIndex, callback, attemptsLeft - 1);
    });
  }

  function getGalleryScopeElement(expectedCount) {
    var controls = document.querySelector('slideshow-controls');
    var node = controls ? (controls.parentElement || controls) : document.body;
    var best = document;
    var depth = 0;
    while (node && depth < 10) {
      var imgs = node.querySelectorAll(GALLERY_IMAGE_SELECTORS.join(','));
      if (imgs.length === expectedCount) return node;
      if (imgs.length >= expectedCount) best = node;
      node = node.parentElement;
      depth++;
    }
    return best;
  }

  function getImageSlideIndex(img, scopeEl) {
    var pool = (scopeEl || document).querySelectorAll(GALLERY_IMAGE_SELECTORS.join(','));
    for (var i = 0; i < pool.length; i++) {
      if (pool[i] === img) return i;
    }
    return -1;
  }

  function findSlideIndexByLabel(label) {
    var scope = getActiveSlideshowComponent();
    var slides = scope.querySelectorAll('slideshow-slide');
    for (var i = 0; i < slides.length; i++) {
      var imgs = slides[i].querySelectorAll('img');
      for (var j = 0; j < imgs.length; j++) {
        if (altMatchesLabel(imgs[j].getAttribute('alt'), label)) return i;
      }
    }
    return -1;
  }

  function goToGallerySlide(label, callback) {
    // gallery slide par pohanchte hi print-area guide (dashed box) dikha do
    function proceed() { callback(); }

    var dots = getDotButtons();

    // NAYA (FIX): dots na milein (numeric "1 / 17" counter wali gallery)
    // -> prev/next arrow buttons se navigate karo.
    if (!dots.length) {
      var targetIndexNoDots = findSlideIndexByLabel(label);
      if (targetIndexNoDots === -1) {
        var matchesNoDots = findAllImagesByAlt(label);
        if (matchesNoDots.length) {
          var targetImgNoDots = matchesNoDots[0];
          var totalSlidesNoDots = getActiveSlideshowComponent().querySelectorAll('slideshow-slide').length;
          var scopeElNoDots = getGalleryScopeElement(totalSlidesNoDots || matchesNoDots.length);
          targetIndexNoDots = getImageSlideIndex(targetImgNoDots, scopeElNoDots);
          if (targetIndexNoDots === -1) targetIndexNoDots = getImageSlideIndex(targetImgNoDots, document);
        }
      }
      if (targetIndexNoDots === -1) {
        console.warn('[sticker-customizer] "' + label + '" image ka slide-index maloom nahi ho saka (counter-style gallery).');
        proceed();
        return;
      }
      navigateByArrowsToIndex(targetIndexNoDots, proceed);
      return;
    }

    var currentIndex = getCurrentDotIndex(dots);
    var targetIndex = findSlideIndexByLabel(label);
    if (targetIndex === -1) {
      var matches = findAllImagesByAlt(label);
      if (matches.length) {
        var targetImg = matches[0];
        var scopeEl = getGalleryScopeElement(dots.length);
        targetIndex = getImageSlideIndex(targetImg, scopeEl);
        if (targetIndex === -1) targetIndex = getImageSlideIndex(targetImg, document);
      }
    }
    if (targetIndex === -1) {
      console.warn('[sticker-customizer] "' + label + '" image ka slide-index maloom nahi ho saka.');
      proceed();
      return;
    }
    if (targetIndex === currentIndex) { proceed(); return; }
    if (dots[targetIndex]) {
      dots[targetIndex].click();
      setTimeout(proceed, 300);
    } else {
      console.warn('[sticker-customizer] "' + label + '" ke liye matching dot button nahi mila (index ' + targetIndex + ').');
      proceed();
    }
  }

  var printAreaGuides = {};

  function createPrintAreaGuide(label) {
    var galleryImg = findGalleryImageByAlt(label) || findGalleryImage(label);
    if (!galleryImg || !galleryImg.parentElement) return null;
    var wrapper = galleryImg.parentElement;
    var computedPos = window.getComputedStyle(wrapper).position;
    if (computedPos === 'static' || !computedPos) wrapper.style.position = 'relative';
    wrapper.classList.add('sc-gallery-target-relative');

    var coords = getPrintAreaCoords(label);

    var box = document.createElement('div');
    box.className = 'sc-print-area-guide';
    box.style.top = coords.top + '%';
    box.style.left = coords.left + '%';
    box.style.width = coords.width + '%';
    box.style.height = coords.height + '%';

    var labelEl = document.createElement('div');
    labelEl.className = 'sc-print-area-label';
    labelEl.textContent = label.toUpperCase() + ' PRINT AREA';
    labelEl.style.top = 'calc(' + coords.top + '% - 16px)';
    labelEl.style.left = coords.left + '%';

    wrapper.appendChild(box);
    wrapper.appendChild(labelEl);

    return { box: box, labelEl: labelEl };
  }

  function showPrintAreaGuideFor(label) {
    if (!label) return;

    Object.keys(printAreaGuides).forEach(function (key) {
      var g = printAreaGuides[key];
      if (!g) return;
      var isCurrent = (key === label);
      if (g.box) g.box.style.display = isCurrent ? 'block' : 'none';
      if (g.labelEl) g.labelEl.style.display = isCurrent ? 'block' : 'none';
    });

    var current = printAreaGuides[label];
    if (!current || !current.box || !current.box.parentElement) {
      printAreaGuides[label] = createPrintAreaGuide(label);
    } else {
      current.box.style.display = 'block';
      current.labelEl.style.display = 'block';
    }
  }

  function syncPrintAreaGuideToOverlay(overlay, label) {
    if (!overlay || !overlay.parentElement || !label) return;
    if (!printAreaGuides[label] || !printAreaGuides[label].box || !printAreaGuides[label].box.parentElement) {
      printAreaGuides[label] = createPrintAreaGuide(label);
    }
    var guide = printAreaGuides[label];
    if (!guide || !guide.box) return;

    var wrapperRect = overlay.parentElement.getBoundingClientRect();
    if (!wrapperRect.width || !wrapperRect.height) return;
    var overlayRect = overlay.getBoundingClientRect();

    var padPct = 4;
    var topPct = Math.max(0, ((overlayRect.top - wrapperRect.top) / wrapperRect.height) * 100 - padPct);
    var leftPct = Math.max(0, ((overlayRect.left - wrapperRect.left) / wrapperRect.width) * 100 - padPct);
    var widthPct = (overlayRect.width / wrapperRect.width) * 100 + padPct * 2;
    var heightPct = (overlayRect.height / wrapperRect.height) * 100 + padPct * 2;

    guide.box.style.top = topPct + '%';
    guide.box.style.left = leftPct + '%';
    guide.box.style.width = widthPct + '%';
    guide.box.style.height = heightPct + '%';
    if (guide.labelEl) {
      guide.labelEl.style.top = 'calc(' + topPct + '% - 16px)';
      guide.labelEl.style.left = leftPct + '%';
    }
  }

  var dragJustHappened = false;
  document.addEventListener('click', function (e) {
    if (dragJustHappened) {
      // Maqsad: drag/resize ke foran baad sticker/image par accidental click
      // suppress karna. Lekin asli controls (Leave Blank, sticker choices,
      // back link, etc.) ko block NAHI karna — warna wo "kaam nahi karte" lagte.
      var isControl = e.target && e.target.closest &&
        e.target.closest('button, a, input, textarea, select, label');
      dragJustHappened = false;
      if (isControl) return;
      e.stopPropagation();
      e.preventDefault();
    }
  }, true);


  var scGlobalState = {};

  function getOrCreateState(widgetId) {
    if (!scGlobalState[widgetId]) {
      scGlobalState[widgetId] = {
        currentStep: 'yes',
        hiddenValues: {},
        selections: { front: null, back: null, placement: null, orderType: null },
        logoDataByPlacement: {}
      };
    }
    return scGlobalState[widgetId];
  }

  function applySavedPosition(overlay, savedPositionStr, updateHandlePositionFn) {
    if (!overlay || !savedPositionStr) return;
    var topMatch = savedPositionStr.match(/top:\s*([^,]+)/);
    var leftMatch = savedPositionStr.match(/left:\s*([^,]+)/);
    var widthMatch = savedPositionStr.match(/width:\s*([^,]+)/);
    var rotateMatch = savedPositionStr.match(/rotate:\s*(-?[\d.]+)deg/);
    if (topMatch) overlay.style.top = topMatch[1].trim();
    if (leftMatch) overlay.style.left = leftMatch[1].trim();
    if (widthMatch) overlay.style.setProperty('width', widthMatch[1].trim(), 'important');
    if (rotateMatch) {
      overlay._scRotation = parseFloat(rotateMatch[1]);
      overlay.style.setProperty('transform', 'rotate(' + overlay._scRotation + 'deg)', 'important');
    }
    if (updateHandlePositionFn) updateHandlePositionFn(overlay);
  }

  // =========================================================
  // Widget init
  // =========================================================

  function initWidget(widget) {
    if (widget.dataset.scInitialized === 'true') return;
    widget.dataset.scInitialized = 'true';

    var widgetId = widget.id;
    var state = getOrCreateState(widgetId);

    var yesStep = widget.querySelector('[data-sc-step="yes"]');
    var emailStep = widget.querySelector('[data-sc-step="email"]');
    var stickersStep = widget.querySelector('[data-sc-step="stickers"]');
    var orderTypeStep = widget.querySelector('[data-sc-step="order-type"]');
    var customOrderStep = widget.querySelector('[data-sc-step="custom-order"]');
    var uploadLogoStep = widget.querySelector('[data-sc-step="upload-logo"]');
    var confirmationStep = widget.querySelector('[data-sc-step="confirmation"]');

    var allSteps = [yesStep, emailStep, stickersStep, orderTypeStep, customOrderStep, uploadLogoStep, confirmationStep];

    function hideAllSteps() {
      allSteps.forEach(function (step) { if (step) step.hidden = true; });
    }

    function showStep(step) {
      hideAllSteps();
      if (step) step.hidden = false;
      state.currentStep = step ? step.getAttribute('data-sc-step') : 'yes';
    }

    function setHidden(el, value) {
      if (!el) return;
      el.value = value;
      var name = el.getAttribute('name');
      if (name) state.hiddenValues[name] = value;
    }

    var yesBtn = widget.querySelector('.sc-yes-btn');
    var noBtn = widget.querySelector('.sc-no-btn');

    if (yesBtn) {
      yesBtn.addEventListener('click', function () {
        yesBtn.classList.add('sc-selected');
        if (noBtn) noBtn.classList.remove('sc-selected');
        showStep(emailStep);
      });
    }
    if (noBtn) {
      // UPDATED: "No" click par ab seedha custom-order link par chala jata hai,
      // order-type step (jisme "Upload my Logo" hota tha) dikhaya hi nahi jata.
      noBtn.addEventListener('click', function () {
        window.location.href = 'https://www.tightlinesapparel.com/pages/cutom-order';
      });
    }

    var backFromEmail = widget.querySelector('.sc-back-from-email');
    var backFromStickers = widget.querySelector('.sc-back-from-stickers');
    var backFromOrderType = widget.querySelector('.sc-back-from-order-type');
    var backFromCustomOrder = widget.querySelector('.sc-back-from-custom-order');
    var backFromUploadLogo = widget.querySelector('.sc-back-from-upload-logo');

    function handleBack(linkEl, targetStep) {
      if (!linkEl) return;
      linkEl.addEventListener('click', function (e) { e.preventDefault(); showStep(targetStep); });
    }
    handleBack(backFromEmail, yesStep);
    handleBack(backFromStickers, emailStep);
    handleBack(backFromOrderType, yesStep);
    handleBack(backFromCustomOrder, orderTypeStep);
    handleBack(backFromUploadLogo, orderTypeStep);

    var emailInput = widget.querySelector('.sc-email-input');
    var findArtworkBtn = widget.querySelector('.sc-find-artwork-btn');

//     // popup logic
//     var openLoginPopupBtn = widget.querySelector('.sc-open-login-popup');
// var openRegisterPopupBtn = widget.querySelector('.sc-open-register-popup');

// if (openLoginPopupBtn) {
//   openLoginPopupBtn.addEventListener('click', function () {
//     openAccountPopup(openLoginPopupBtn.getAttribute('data-login-url'));
//   });
// }
// if (openRegisterPopupBtn) {
//   openRegisterPopupBtn.addEventListener('click', function () {
//     openAccountPopup(openRegisterPopupBtn.getAttribute('data-register-url'));
//   });
// }
//     // popup logic

    var emailError = widget.querySelector('.sc-email-error');
    var hiddenEmail = widget.querySelector('.sc-hidden-email');

    function isValidEmail(value) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value); }

    function lookupAndApplySavedLogo(email) {
      if (!LOGO_API_URL || LOGO_API_URL.indexOf('YOUR-SUBDOMAIN') !== -1) {
        console.warn('[sticker-customizer] LOGO_API_URL set nahi hua — logo lookup skip.');
        return Promise.resolve(false);
      }
      return fetch(LOGO_API_URL + '/get-logo?email=' + encodeURIComponent(email))
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (data && data.found && data.logoUrl) {
            var placementVal = data.placement || 'Front';
            setHidden(hiddenPlacement, placementVal);
            logoDataByPlacement[placementVal] = { file: null, dataUrl: data.logoUrl };
            state.selections.placement = placementVal;
            showLogoOverlay(data.logoUrl);
            return true;
          }
          return false;
        })
        .catch(function (err) {
          console.warn('[sticker-customizer] Logo lookup failed:', err);
          return false;
        });
    }

    if (findArtworkBtn) {
      findArtworkBtn.addEventListener('click', function () {
        var value = emailInput ? emailInput.value.trim() : '';
        if (!isValidEmail(value)) { if (emailError) emailError.hidden = false; return; }
        if (emailError) emailError.hidden = true;
        setHidden(hiddenEmail, value);

        var originalLabel = findArtworkBtn.textContent;
        findArtworkBtn.disabled = true;
        findArtworkBtn.textContent = 'Looking up your artwork...';

        lookupAndApplySavedLogo(value).then(function () {
          findArtworkBtn.disabled = false;
          findArtworkBtn.textContent = originalLabel;
          showStep(stickersStep);
        });
      });
    }

    var frontChoices = widget.querySelectorAll('.sc-front-choice');
    var backChoices = widget.querySelectorAll('.sc-back-choice');
    var leaveBlankFrontBtn = widget.querySelector('.sc-leave-blank-front');
    var leaveBlankBackBtn = widget.querySelector('.sc-leave-blank-back');

    var frontBlock = widget.querySelector('[data-sc-block="front"]');
    var backBlock = widget.querySelector('[data-sc-block="back"]');
    if (frontBlock) frontBlock.hidden = !findAllImagesByAlt('front').length;
    if (backBlock) backBlock.hidden = !findAllImagesByAlt('back').length;

    // NAYA (2026-09-13, v4): "sticker" tag wale products par "Select back"
    // hamesha hidden rakho — customer ko sirf front wala option dikhe.
    // Baaki products par is line ka koi asar nahi.
    if (backBlock && isStickerProduct(widget)) backBlock.hidden = true;
    // back hidden
        // NAYA: "noback" tag wale products par back logo options show hi nahi honge
    if (backBlock && isNoBackProduct(widget)) backBlock.hidden = true;
    // back hidden
        // front hidden
    // NAYA: "nofront" tag wale products par front logo options show hi nahi honge
    if (frontBlock && isNoFrontProduct(widget)) frontBlock.hidden = true;
    // front hidden

   
    var isSingleSideFront = !!(backBlock && !backBlock.hidden && (!frontBlock || frontBlock.hidden) && !isHatProduct(widget));

    relabelBackAsFront(widget);

    var hiddenFrontSticker = widget.querySelector('.sc-hidden-front-sticker');
    var hiddenFrontPosition = widget.querySelector('.sc-hidden-front-position');
    var hiddenBackSticker = widget.querySelector('.sc-hidden-back-sticker');
    var hiddenBackPosition = widget.querySelector('.sc-hidden-back-position');

    var frontOverlay = null;
    var backOverlay = null;
    var logoOverlay = null;

    // sticker text 
      var PROOF_NOTICE_TEXT = 'These proofs are just for reference. Final placement is done by hand by our team to ensure appropriate sizing and location.';

  function ensureProofNoticeStyles() {
    if (document.getElementById('sc-proof-notice-styles')) return;
    var style = document.createElement('style');
    style.id = 'sc-proof-notice-styles';
    style.textContent =
      '.sc-proof-notice{position:absolute;background:rgba(0,0,0,0.75);color:#fff;' +
      'font-size:11px;line-height:1.35;text-align:center;padding:8px 10px;' +
      'border-radius:6px;pointer-events:none;z-index:99;box-sizing:border-box;}';
    document.head.appendChild(style);
  }

  function createProofNotice(wrapper) {
    ensureProofNoticeStyles();
    var notice = document.createElement('div');
    notice.className = 'sc-proof-notice';
    notice.textContent = PROOF_NOTICE_TEXT;
    notice.style.top = '88%';
    notice.style.left = '5%';
    notice.style.width = '90%';
    wrapper.appendChild(notice);
    return notice;
  }

  function refreshProofNotice(wrapper) {
    if (!wrapper) return;
    var hasOverlay = !!wrapper.querySelector('.sc-gallery-sticker-overlay');
    if (hasOverlay) {
      if (!wrapper._scProofNotice || !wrapper._scProofNotice.parentElement) {
        wrapper._scProofNotice = createProofNotice(wrapper);
      }
    } else if (wrapper._scProofNotice) {
      if (wrapper._scProofNotice.parentElement) {
        wrapper._scProofNotice.parentElement.removeChild(wrapper._scProofNotice);
      }
      wrapper._scProofNotice = null;
    }
  }
 
    function createOverlay(label, onDelete) {
      var galleryImg = findGalleryImageByAlt(label) || findImageByAltAnyVisibility(label) || findGalleryImage(label);
      var overlay = document.createElement('img');
      overlay.className = 'sc-gallery-sticker-overlay';
      overlay.setAttribute('draggable', 'false');

      var coords = getPrintAreaCoords(label);
      var startWidth = label.toLowerCase() === 'back'
  ? Math.min(32, coords.width)
  : Math.min(21, coords.width);
      overlay.style.setProperty('width', startWidth + '%', 'important');
      overlay.style.setProperty('height', 'auto', 'important');
      overlay.style.setProperty('min-width', '30px', 'important');
      overlay.style.setProperty('object-fit', 'contain', 'important');
      overlay.style.setProperty('touch-action', 'none', 'important');
      overlay.style.setProperty('user-select', 'none', 'important');
      overlay.style.setProperty('-webkit-user-drag', 'none', 'important');
      overlay.style.setProperty('pointer-events', 'auto', 'important');
      overlay.style.setProperty('transform-origin', 'center center', 'important');
      overlay.style.top = coords.top + '%';
      overlay.style.left = coords.left + '%';
      overlay._scRotation = 0;
      overlay._scLabel = label;

      if (galleryImg && galleryImg.parentElement) {
        var wrapper = galleryImg.parentElement;
        var computedPos = window.getComputedStyle(wrapper).position;
        if (computedPos === 'static' || !computedPos) wrapper.style.position = 'relative';
        wrapper.classList.add('sc-gallery-target-relative');
        overlay.style.setProperty('position', 'absolute', 'important');
        overlay.style.setProperty('z-index', '100', 'important');
        /* NAYA (2026-09-10): drag band — cursor "grab" hata diya gaya hai */
        wrapper.appendChild(overlay);
        // sticker text
          refreshProofNotice(wrapper);
      } else {
        overlay.style.position = 'relative';
        overlay.style.display = 'inline-block';
        overlay.style.margin = '12px auto';
        widget.appendChild(overlay);
      }

      overlay.addEventListener('load', function () { updateHandlePosition(overlay); });
      return overlay;
    }

    function destroyOverlay(overlay) {
      if (!overlay) return;
      var overlayWrapper = overlay.parentElement;
      if (overlay._scResizeHandle && overlay._scResizeHandle.parentElement) {
        overlay._scResizeHandle.parentElement.removeChild(overlay._scResizeHandle);
      }
      if (overlay._scRotateHandle && overlay._scRotateHandle.parentElement) {
        overlay._scRotateHandle.parentElement.removeChild(overlay._scRotateHandle);
      }
      if (overlay._scDeleteHandle && overlay._scDeleteHandle.parentElement) {
        overlay._scDeleteHandle.parentElement.removeChild(overlay._scDeleteHandle);
      }
      if (overlay.parentElement) overlay.parentElement.removeChild(overlay);
      refreshProofNotice(overlayWrapper);
    }

    function saveFrontPosition() {
      if (!frontOverlay || !hiddenFrontPosition) return;
      setHidden(hiddenFrontPosition, 'top: ' + frontOverlay.style.top + ', left: ' + frontOverlay.style.left + ', width: ' + frontOverlay.style.width + ', rotate: ' + (frontOverlay._scRotation || 0) + 'deg');
    }
    function saveBackPosition() {
      if (!backOverlay || !hiddenBackPosition) return;
      setHidden(hiddenBackPosition, 'top: ' + backOverlay.style.top + ', left: ' + backOverlay.style.left + ', width: ' + backOverlay.style.width + ', rotate: ' + (backOverlay._scRotation || 0) + 'deg');
    }

    function deleteFrontSticker() {
      destroyOverlay(frontOverlay);
      frontOverlay = null;
      setHidden(hiddenFrontSticker, '');
      setHidden(hiddenFrontPosition, '');
      frontChoices.forEach(function (c) { c.classList.remove('sc-selected'); });
      state.selections.front = null;
    }
    function deleteBackSticker() {
      destroyOverlay(backOverlay);
      backOverlay = null;
      setHidden(hiddenBackSticker, '');
      setHidden(hiddenBackPosition, '');
      backChoices.forEach(function (c) { c.classList.remove('sc-selected'); });
      state.selections.back = null;
    }

    var dragBound = new WeakSet();

    function updateHandlePosition(overlay) {
      var resizeHandle = overlay._scResizeHandle;
      if (resizeHandle) {
        resizeHandle.style.left = (overlay.offsetLeft + overlay.offsetWidth) + 'px';
        resizeHandle.style.top = (overlay.offsetTop + overlay.offsetHeight) + 'px';
      }
      var deleteHandle = overlay._scDeleteHandle;
      if (deleteHandle) {
        deleteHandle.style.left = overlay.offsetLeft + 'px';
        deleteHandle.style.top = overlay.offsetTop + 'px';
      }
      var rotateHandle = overlay._scRotateHandle;
      if (rotateHandle) {
        rotateHandle.style.left = overlay.offsetLeft + 'px';
        rotateHandle.style.top = (overlay.offsetTop + overlay.offsetHeight) + 'px';
      }
    }

    function createResizeHandle(overlay) {
      var handle = document.createElement('div');
      handle.className = 'sc-gallery-sticker-resize-handle';
      handle.setAttribute('draggable', 'false');
      handle.style.setProperty('position', 'absolute', 'important');
      handle.style.setProperty('width', '18px', 'important');
      handle.style.setProperty('height', '18px', 'important');
      handle.style.setProperty('border-radius', '50%', 'important');
      handle.style.setProperty('background', '#ffffff', 'important');
      handle.style.setProperty('border', '2px solid #1a1a1a', 'important');
      handle.style.setProperty('box-shadow', '0 1px 4px rgba(0,0,0,0.5)', 'important');
      handle.style.setProperty('cursor', 'nwse-resize', 'important');
      handle.style.setProperty('z-index', '101', 'important');
      handle.style.setProperty('touch-action', 'none', 'important');
      handle.style.setProperty('user-select', 'none', 'important');
      handle.style.setProperty('transform', 'translate(-50%, -50%)', 'important');
      handle.style.setProperty('pointer-events', 'auto', 'important');

      var wrapper = overlay.parentElement;
      if (wrapper) wrapper.appendChild(handle);
      else overlay.insertAdjacentElement('afterend', handle);

      overlay._scResizeHandle = handle;
      updateHandlePosition(overlay);
      return handle;
    }

    function createDeleteHandle(overlay, onDelete) {
      var handle = document.createElement('div');
      handle.className = 'sc-gallery-sticker-delete-handle';
      handle.setAttribute('draggable', 'false');
      handle.innerHTML = '&times;';
      handle.style.setProperty('position', 'absolute', 'important');
      handle.style.setProperty('width', '18px', 'important');
      handle.style.setProperty('height', '18px', 'important');
      handle.style.setProperty('border-radius', '50%', 'important');
      handle.style.setProperty('background', '#e0332f', 'important');
      handle.style.setProperty('color', '#ffffff', 'important');
      handle.style.setProperty('border', '2px solid #ffffff', 'important');
      handle.style.setProperty('box-shadow', '0 1px 4px rgba(0,0,0,0.5)', 'important');
      handle.style.setProperty('cursor', 'pointer', 'important');
      handle.style.setProperty('z-index', '102', 'important');
      handle.style.setProperty('touch-action', 'none', 'important');
      handle.style.setProperty('user-select', 'none', 'important');
      handle.style.setProperty('transform', 'translate(-50%, -50%)', 'important');
      handle.style.setProperty('pointer-events', 'auto', 'important');
      handle.style.setProperty('display', 'flex', 'important');
      handle.style.setProperty('align-items', 'center', 'important');
      handle.style.setProperty('justify-content', 'center', 'important');
      handle.style.setProperty('font-size', '13px', 'important');
      handle.style.setProperty('line-height', '1', 'important');

      var wrapper = overlay.parentElement;
      if (wrapper) wrapper.appendChild(handle);
      else overlay.insertAdjacentElement('afterend', handle);

      handle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (onDelete) onDelete();
      });
      handle.addEventListener('mousedown', function (e) { e.stopPropagation(); });
      handle.addEventListener('touchstart', function (e) { e.stopPropagation(); }, { passive: true });

      overlay._scDeleteHandle = handle;
      return handle;
    }

    function createRotateHandle(overlay) {
      var handle = document.createElement('div');
      handle.className = 'sc-gallery-sticker-rotate-handle';
      handle.setAttribute('draggable', 'false');
      handle.innerHTML = '&#8635;';
      handle.style.setProperty('position', 'absolute', 'important');
      handle.style.setProperty('width', '18px', 'important');
      handle.style.setProperty('height', '18px', 'important');
      handle.style.setProperty('border-radius', '50%', 'important');
      handle.style.setProperty('background', '#1f8a5f', 'important');
      handle.style.setProperty('color', '#ffffff', 'important');
      handle.style.setProperty('border', '2px solid #ffffff', 'important');
      handle.style.setProperty('box-shadow', '0 1px 4px rgba(0,0,0,0.5)', 'important');
      handle.style.setProperty('cursor', 'alias', 'important');
      handle.style.setProperty('z-index', '102', 'important');
      handle.style.setProperty('touch-action', 'none', 'important');
      handle.style.setProperty('user-select', 'none', 'important');
      handle.style.setProperty('transform', 'translate(-50%, -50%)', 'important');
      handle.style.setProperty('pointer-events', 'auto', 'important');
      handle.style.setProperty('display', 'flex', 'important');
      handle.style.setProperty('align-items', 'center', 'important');
      handle.style.setProperty('justify-content', 'center', 'important');
      handle.style.setProperty('font-size', '12px', 'important');
      handle.style.setProperty('line-height', '1', 'important');

      var wrapper = overlay.parentElement;
      if (wrapper) wrapper.appendChild(handle);
      else overlay.insertAdjacentElement('afterend', handle);

      overlay._scRotateHandle = handle;
      return handle;
    }

    function setupResize(overlay, onResizeEnd) {
      var handle = overlay._scResizeHandle;
      if (!handle || dragBound.has(handle)) return;
      dragBound.add(handle);
      var isResizing = false, startX, startWidthPx;

      function onStart(clientX) { isResizing = true; startX = clientX; startWidthPx = overlay.getBoundingClientRect().width; }
      function onMove(clientX) {
        if (!isResizing) return;
        var wrapper = overlay.parentElement;
        if (!wrapper) return;
        var wrapperWidth = wrapper.getBoundingClientRect().width;
        var deltaX = clientX - startX;
        var newWidthPx = startWidthPx + deltaX;
        var minWidth = 30, maxWidth = wrapperWidth * 0.6;
        newWidthPx = Math.max(minWidth, Math.min(maxWidth, newWidthPx));
        overlay.style.setProperty('width', newWidthPx + 'px', 'important');
        updateHandlePosition(overlay);
        dragJustHappened = true;
      }
      function onEnd() { if (!isResizing) return; isResizing = false; onResizeEnd(); }

      handle.addEventListener('mousedown', function (e) { e.preventDefault(); e.stopPropagation(); onStart(e.clientX); });
      document.addEventListener('mousemove', function (e) { onMove(e.clientX); });
      document.addEventListener('mouseup', onEnd);
      handle.addEventListener('touchstart', function (e) { e.stopPropagation(); var t = e.touches[0]; onStart(t.clientX); }, { passive: true });
      document.addEventListener('touchmove', function (e) { if (!isResizing) return; var t = e.touches[0]; onMove(t.clientX); }, { passive: true });
      document.addEventListener('touchend', onEnd);
    }

    function setupRotate(overlay, onRotateEnd) {
      var handle = overlay._scRotateHandle;
      if (!handle || dragBound.has(handle)) return;
      dragBound.add(handle);
      var isRotating = false, startAngle = 0, startRotation = 0, centerX = 0, centerY = 0;

      function angleFromCenter(clientX, clientY) {
        return Math.atan2(clientY - centerY, clientX - centerX) * (180 / Math.PI);
      }
      function onStart(clientX, clientY) {
        isRotating = true;
        var rect = overlay.getBoundingClientRect();
        centerX = rect.left + rect.width / 2;
        centerY = rect.top + rect.height / 2;
        startAngle = angleFromCenter(clientX, clientY);
        startRotation = overlay._scRotation || 0;
      }
      function onMove(clientX, clientY) {
        if (!isRotating) return;
        var currentAngle = angleFromCenter(clientX, clientY);
        var newRotation = startRotation + (currentAngle - startAngle);
        overlay._scRotation = newRotation;
        overlay.style.setProperty('transform', 'rotate(' + newRotation + 'deg)', 'important');
        updateHandlePosition(overlay);
        dragJustHappened = true;
      }
      function onEnd() { if (!isRotating) return; isRotating = false; onRotateEnd(); }

      handle.addEventListener('mousedown', function (e) { e.preventDefault(); e.stopPropagation(); onStart(e.clientX, e.clientY); });
      document.addEventListener('mousemove', function (e) { onMove(e.clientX, e.clientY); });
      document.addEventListener('mouseup', onEnd);
      handle.addEventListener('touchstart', function (e) { e.stopPropagation(); var t = e.touches[0]; onStart(t.clientX, t.clientY); }, { passive: true });
      document.addEventListener('touchmove', function (e) { if (!isRotating) return; var t = e.touches[0]; onMove(t.clientX, t.clientY); }, { passive: true });
      document.addEventListener('touchend', onEnd);
    }

    function setupDrag(overlay, onDrop) {
      // Drag-drop poori tarah band — jaan-boojh kar khali chhoda gaya hai.
      return;
    }

    frontChoices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        var src = choice.getAttribute('data-sticker-src');
        var label = choice.getAttribute('data-sticker-label');
        // NAYA: is button ka start position (center ya upper-left)
        var startKey = choice.getAttribute('data-start') || 'center';
        var startPos = FRONT_START_POSITIONS[startKey] || FRONT_START_POSITIONS['center'];

        if (isLowerPositionProduct()) {
          startPos = LOWER_FRONT_POSITION;
        }



        // if (isWomensProduct()) {
        //   startPos = FRONT_WOMENS_RIGHT_CHEST_POSITION;
        // } else if (label === 'My Logo') {
        //   // NAYA (2026-09-10, v2): "if customer" wale branch ("My Logo")
        //   // ke liye — jab product women's NA ho — left ko 50% force karo.
        //   // Static/guest stickers (else branch, jaise "boat") is se
        //   // touch nahi hote — unka pehle jaisa (data-start based)
        //   // behavior bilkul same rehta hai.
        //   startPos = FRONT_MENS_LOGO_POSITION;
        // }
        if (isWomensProduct()) {
          startPos = FRONT_WOMENS_RIGHT_CHEST_POSITION;
        } else if (/^My Logo/.test(label)) {
          startPos = FRONT_MENS_LOGO_POSITION;
        }







        // NAYA (tag-based override — SABSE ZYADA priority):
        // agar product par "left"/"right" tag laga ho to upar ke
        // tamam overrides ko replace kar dega. Tag na ho to kuch
        // change nahi hota.
        var tagPos = getTagBasedFrontPosition(widget);
        if (tagPos) {
          startPos = tagPos;
        }

        var topOverride = getTagBasedTopOverride(widget);
        if (topOverride !== null) {
          startPos = { top: topOverride, left: startPos.left };
        }

        // NAYA (2026-09-13, v3): numeric "leftXX" tag — isi tarah sirf
        // LEFT % ko override karta hai, TOP (chahe abhi upar wale topXX
        // block se aaya ho ya kisi aur logic se) bilkul chhua nahi jata.
        // Tag na ho to kuch bhi nahi hota — purana behavior 100% same.
        var leftOverride = getTagBasedLeftOverride(widget);
        if (leftOverride !== null) {
          startPos = { top: startPos.top, left: leftOverride };
        }

        // NAYA (2026-09-13, v4): "sticker" tag — sabse aakhir aur sabse
        // zyada priority. Front logo/sticker hamesha top:25%, left:25%
        // par start hoga, chahe upar koi bhi doosra override (topXX,
        // leftXX, women's, My Logo, left/right tag) laga ho. Tag na ho
        // to ye block kuch bhi nahi karta.
        if (isStickerProduct(widget)) {
          startPos = STICKER_FRONT_POSITION;
        }

        // NAYA: agar is product ki gallery mein koi bhi image alt="front"
        // wali nahi hai, to front sticker bilkul add nahi karna
        // (kisi random/fallback image par nahi lagana).
        if (!findAllImagesByAlt('front').length) {
          console.warn('[sticker-customizer] Is product mein "front" (alt="front") wali image nahi mili — front sticker add nahi kiya ja sakta.');
          frontChoices.forEach(function (c) { c.classList.remove('sc-selected'); });
          destroyOverlay(frontOverlay);
          frontOverlay = null;
          setHidden(hiddenFrontSticker, '');
          setHidden(hiddenFrontPosition, '');
          state.selections.front = null;
          return;
        }

        frontChoices.forEach(function (c) { c.classList.remove('sc-selected'); });
        choice.classList.add('sc-selected');
        if (leaveBlankFrontBtn) leaveBlankFrontBtn.classList.remove('sc-selected');

        goToGallerySlide('front', function () {
          var targetImg = findGalleryImageByAlt('front') || findImageByAltAnyVisibility('front') || findGalleryImage('front');
          var targetWrapper = targetImg ? targetImg.parentElement : null;
          if (!frontOverlay || frontOverlay.parentElement !== targetWrapper) {
            destroyOverlay(frontOverlay);
            frontOverlay = createOverlay('front', deleteFrontSticker);
          }
          frontOverlay.src = src;
          frontOverlay.hidden = false;

          // NAYA: overlay ko apne button ke hisaab se sahi jagah par set karo
          frontOverlay.style.top = startPos.top + '%';
          frontOverlay.style.left = startPos.left + '%';
          // NAYA: "sticker" tag wale products par front logo ki width bhi 50% fix
          if (isStickerProduct(widget)) {
            frontOverlay.style.setProperty('width', '50%', 'important');
          }

          updateHandlePosition(frontOverlay);

          /* NAYA (2026-09-10): drag band kar diya gaya hai */
          // setupDrag(frontOverlay, saveFrontPosition);
          setHidden(hiddenFrontSticker, label);
          saveFrontPosition();
          state.selections.front = { label: label, src: src, start: startKey };
        });
      });
    });

    backChoices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        var src = choice.getAttribute('data-sticker-src');
        var label = choice.getAttribute('data-sticker-label');

        // NAYA: agar is product ki gallery mein koi bhi image alt="back"
        // wali nahi hai, to back sticker bilkul add nahi karna
        // (kisi random/fallback image par nahi lagana).
        if (!findAllImagesByAlt('back').length) {
          console.warn('[sticker-customizer] Is product mein "back" (alt="back") wali image nahi mili — back sticker add nahi kiya ja sakta.');
          backChoices.forEach(function (c) { c.classList.remove('sc-selected'); });
          destroyOverlay(backOverlay);
          backOverlay = null;
          setHidden(hiddenBackSticker, '');
          setHidden(hiddenBackPosition, '');
          state.selections.back = null;
          return;
        }

        backChoices.forEach(function (c) { c.classList.remove('sc-selected'); });
        choice.classList.add('sc-selected');
        if (leaveBlankBackBtn) leaveBlankBackBtn.classList.remove('sc-selected');

        goToGallerySlide('back', function () {
          var targetImg = findGalleryImageByAlt('back') || findImageByAltAnyVisibility('back') || findGalleryImage('back');
          var targetWrapper = targetImg ? targetImg.parentElement : null;
          if (!backOverlay || backOverlay.parentElement !== targetWrapper) {
            destroyOverlay(backOverlay);
            backOverlay = createOverlay('back', deleteBackSticker);
          }
          backOverlay.src = src;
          backOverlay.hidden = false;

          // NAYA: single-side "Select Front" product par sticker apni
          // per-product position par start hoga (default center; kuch
          // products left waghera — SINGLE_SIDE_FRONT_BY_HANDLE dekhein).
          if (isSingleSideFront) {
            var ssPos = getSingleSideFrontPosition();
            backOverlay.style.top = ssPos.top + '%';
            backOverlay.style.left = ssPos.left + '%';
            updateHandlePosition(backOverlay);
          } else if (isLowerPositionProduct()) {
            // NAYA (2026-09-07): specific product (jaise shorts) ke liye
            // back sticker "niche + center" par override start hota hai —
            // sirf isi "Yes" flow ke sticker-selection step mein.
            backOverlay.style.top = LOWER_BACK_POSITION.top + '%';
            backOverlay.style.left = LOWER_BACK_POSITION.left + '%';
            updateHandlePosition(backOverlay);
          }
                   else if (isHatProduct(widget)) {
            // NAYA: "hat" products ka asal front hi back-button se control
            // hota hai, isliye topXX/leftXX tag yahan bhi kaam karna chahiye.
            var hatTopOverride = getTagBasedTopOverride(widget);
            var hatLeftOverride = getTagBasedLeftOverride(widget);
            if (hatTopOverride !== null) backOverlay.style.top = hatTopOverride + '%';
            if (hatLeftOverride !== null) backOverlay.style.left = hatLeftOverride + '%';
            if (hatTopOverride !== null || hatLeftOverride !== null) updateHandlePosition(backOverlay);
          }
          // back top position
                    // NAYA: generic "backtop-XX" tag override — front ki left/top
          // functionality jaisi, lekin BACK ke liye sirf TOP. Ye upar wale
          // single-side/lower-position/hat overrides ke BAAD chalta hai,
          // isliye unka behavior bilkul same rehta hai; agar ye tag maujood
          // hai to sirf top ko final set karta hai (left ko haath nahi lagata).
          var backTopOverride = getTagBasedBackTopOverride(widget);
          if (backTopOverride !== null) {
            backOverlay.style.top = backTopOverride + '%';
            updateHandlePosition(backOverlay);
          }
          // back top position

                    // back left position
          // NAYA: "backleft-XX" tag — sirf LEFT set karta hai, TOP ko haath nahi lagata.
          var backLeftOverride = getTagBasedBackLeftOverride(widget);
          if (backLeftOverride !== null) {
            backOverlay.style.left = backLeftOverride + '%';
            updateHandlePosition(backOverlay);
          }
          // back left position

          /* NAYA (2026-09-10): drag band kar diya gaya hai */
          // setupDrag(backOverlay, saveBackPosition);
          setHidden(hiddenBackSticker, label);
          saveBackPosition();
          state.selections.back = { label: label, src: src };
        });
      });
    });

    // NAYA (2026-09-09): ab do alag "Leave Blank" buttons hain —
    //  - front block ka (.sc-leave-blank-front) sirf FRONT sticker clear kare
    //  - back block ka  (.sc-leave-blank-back)  sirf BACK sticker clear kare
    // Robust: 'pointerup' + 'click' dono par, aur pending drag-suppression
    // clear karta hai, taake har surat mein chale.
    function bindLeaveBlank(btn, clearFn) {
      if (!btn) return;
      var handler = function (e) {
        if (e) { e.preventDefault(); e.stopPropagation(); }
        dragJustHappened = false;
        clearFn();
        btn.classList.add('sc-selected');
      };
      btn.addEventListener('pointerup', handler);
      btn.addEventListener('click', handler);
    }
    bindLeaveBlank(leaveBlankFrontBtn, deleteFrontSticker);
    bindLeaveBlank(leaveBlankBackBtn, deleteBackSticker);

    var orderOptions = widget.querySelectorAll('.sc-order-option');
    var hiddenOrderType = widget.querySelector('.sc-hidden-order-type');

    orderOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        var type = option.getAttribute('data-order-type');
        setHidden(hiddenOrderType, type === 'custom' ? 'Custom Order' : 'Upload Logo');
        orderOptions.forEach(function (o) { o.classList.remove('sc-selected'); });
        option.classList.add('sc-selected');
        state.selections.orderType = type === 'custom' ? 'Custom Order' : 'Upload Logo';

        if (type === 'custom') {
          if (customOrderStep) showStep(customOrderStep);
        } else {
          showStep(uploadLogoStep);
        }
      });
    });

    var garmentChoices = widget.querySelectorAll('.sc-garment-choice');
    var hiddenGarment = widget.querySelector('.sc-hidden-garment');
    garmentChoices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        setHidden(hiddenGarment, choice.getAttribute('data-garment'));
        garmentChoices.forEach(function (c) { c.classList.remove('sc-selected'); });
        choice.classList.add('sc-selected');
      });
    });

    var qtyCustomInput = widget.querySelector('.sc-qty-custom');
    var qtyUploadInput = widget.querySelector('.sc-qty-upload');

    function syncRealQuantity(value) {
      var realQtyInput = findRealQuantityInput();
      if (realQtyInput) {
        realQtyInput.value = value;
        realQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    widget.querySelectorAll('.sc-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-qty-target');
        var input = target === 'custom' ? qtyCustomInput : qtyUploadInput;
        if (!input) return;
        var current = parseInt(input.value, 10) || 1;
        if (btn.classList.contains('sc-qty-plus')) current += 1;
        else if (current > 1) current -= 1;
        input.value = current;
      });
    });

    [qtyCustomInput, qtyUploadInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('change', function () {
        var value = parseInt(input.value, 10);
        if (!value || value < 1) value = 1;
        input.value = value;
      });
    });

    var checkoutBtn = widget.querySelector('.sc-checkout-btn');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        syncRealQuantity(qtyCustomInput ? qtyCustomInput.value : 1);
        showStep(confirmationStep);
      });
    }

    var placementChoices = widget.querySelectorAll('.sc-placement-choice');
    var hiddenPlacement = widget.querySelector('.sc-hidden-placement');
    var logoFileInput = widget.querySelector('.sc-logo-file-input');
    var uploadFilenameEl = widget.querySelector('.sc-upload-filename');

    var logoDataByPlacement = state.logoDataByPlacement;

    function placementToGalleryLabel(placementValue) {
      var v = (placementValue || '').toLowerCase();
      if (v.indexOf('left') !== -1 && v.indexOf('sleeve') !== -1) return 'left sleeve';
      if (v.indexOf('right') !== -1 && v.indexOf('sleeve') !== -1) return 'right sleeve';
      if (v.indexOf('front') !== -1) return 'front';
      if (v.indexOf('back') !== -1) return 'back';
      return 'front';
    }

    function getLogoPlacementLabel() {
      return placementToGalleryLabel(hiddenPlacement ? hiddenPlacement.value : '');
    }

    function deleteLogo() {
      var currentPlacement = hiddenPlacement ? hiddenPlacement.value : '';
      destroyOverlay(logoOverlay);
      logoOverlay = null;
      delete logoDataByPlacement[currentPlacement];
      if (uploadFilenameEl) uploadFilenameEl.textContent = '';
      if (logoFileInput) logoFileInput.value = '';
    }

    function showLogoOverlay(dataUrl) {
      var label = getLogoPlacementLabel();
      goToGallerySlide(label, function () {
        var targetImg = findGalleryImageByAlt(label) || findGalleryImage(label);
        var targetWrapper = targetImg ? targetImg.parentElement : null;
        if (!logoOverlay || logoOverlay.parentElement !== targetWrapper) {
          destroyOverlay(logoOverlay);
          logoOverlay = createOverlay(label, deleteLogo);
        }
        logoOverlay.src = dataUrl;
        logoOverlay.hidden = false;

        // NAYA (2026-09-08): caps/shorts jaise products ke liye FRONT
        // logo ko "upar + thoda left" par override karna — sirf FRONT
        // placement ke liye, sirf isi one-time upload flow mein.
        if (label === 'front' && isUploadFrontUpperLeftProduct()) {
          var upperLeftPos = FRONT_START_POSITIONS['upper-left'];
          logoOverlay.style.top = upperLeftPos.top + '%';
          logoOverlay.style.left = upperLeftPos.left + '%';
          updateHandlePosition(logoOverlay);
        }

        /* NAYA (2026-09-10): drag band kar diya gaya hai */
        // setupDrag(logoOverlay, function () {});
      });
    }

    function removeLogoOverlay() { destroyOverlay(logoOverlay); logoOverlay = null; }

    function restoreFileInputFile(file) {
      if (!file || !logoFileInput) return;
      try {
        var dt = new DataTransfer();
        dt.items.add(file);
        logoFileInput.files = dt.files;
      } catch (e) {
        console.warn('[sticker-customizer] File input dobara set nahi ho saka:', e);
      }
    }

    function showPlacementLogo(placementValue) {
      var entry = logoDataByPlacement[placementValue];
      if (entry) {
        if (uploadFilenameEl) uploadFilenameEl.textContent = entry.file ? ('Selected: ' + entry.file.name) : 'Logo loaded from your previous order';
        if (entry.file) restoreFileInputFile(entry.file);
        if (entry.dataUrl) showLogoOverlay(entry.dataUrl);
        else removeLogoOverlay();
      } else {
        if (uploadFilenameEl) uploadFilenameEl.textContent = '';
        if (logoFileInput) logoFileInput.value = '';
        removeLogoOverlay();
      }
    }

    placementChoices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        var placementValue = choice.getAttribute('data-placement');
        setHidden(hiddenPlacement, placementValue);
        placementChoices.forEach(function (c) { c.classList.remove('sc-selected'); });
        choice.classList.add('sc-selected');
        state.selections.placement = placementValue;

        goToGallerySlide(placementToGalleryLabel(placementValue), function () {});

        showPlacementLogo(placementValue);
      });
    });

    if (logoFileInput) {
      logoFileInput.addEventListener('change', function () {
        var currentPlacement = hiddenPlacement ? hiddenPlacement.value : '';
        if (logoFileInput.files && logoFileInput.files[0]) {
          var file = logoFileInput.files[0];
          if (uploadFilenameEl) uploadFilenameEl.textContent = 'Selected: ' + file.name;
          if (file.type && file.type.indexOf('image/') === 0) {
            var reader = new FileReader();
            reader.onload = function (e) {
              logoDataByPlacement[currentPlacement] = { file: file, dataUrl: e.target.result };
              showLogoOverlay(e.target.result);
            };
            reader.readAsDataURL(file);
          } else {
            logoDataByPlacement[currentPlacement] = { file: file, dataUrl: null };
            removeLogoOverlay();
          }
        } else {
          delete logoDataByPlacement[currentPlacement];
          if (uploadFilenameEl) uploadFilenameEl.textContent = '';
          removeLogoOverlay();
        }
      });
    }

    var uploadCheckoutBtn = widget.querySelector('.sc-upload-checkout-btn');
    if (uploadCheckoutBtn) {
      uploadCheckoutBtn.addEventListener('click', function () {
        syncRealQuantity(qtyUploadInput ? qtyUploadInput.value : 1);
        showStep(confirmationStep);
      });
    }

    var runAgainBtn = widget.querySelector('.sc-run-again-btn');
    if (runAgainBtn) {
      runAgainBtn.addEventListener('click', function () { showStep(yesStep); });
    }

    // =========================================================
    // RESTORE: agar is widgetId ke liye pehle se koi saved state
    // maujood hai (yani ye ek re-render/morph ke baad ka naya
    // widget hai), sab kuch wapis laga do.
    // =========================================================
    function restoreState() {
      Object.keys(state.hiddenValues).forEach(function (name) {
        var el = widget.querySelector('[name="' + name.replace(/"/g, '\\"') + '"]');
        if (el) el.value = state.hiddenValues[name];
      });

      var stepEl = widget.querySelector('[data-sc-step="' + state.currentStep + '"]');
      if (stepEl) showStep(stepEl); else showStep(yesStep);

      if (state.selections.front) {
        var fBtn = widget.querySelector('.sc-front-choice[data-sticker-label="' + state.selections.front.label + '"]');
        if (fBtn) fBtn.classList.add('sc-selected');
        goToGallerySlide('front', function () {
          var targetImg = findGalleryImageByAlt('front') || findImageByAltAnyVisibility('front') || findGalleryImage('front');
          var targetWrapper = targetImg ? targetImg.parentElement : null;
          if (!frontOverlay || frontOverlay.parentElement !== targetWrapper) {
            destroyOverlay(frontOverlay);
            frontOverlay = createOverlay('front', deleteFrontSticker);
          }
          frontOverlay.src = state.selections.front.src;
          frontOverlay.hidden = false;
          applySavedPosition(frontOverlay, hiddenFrontPosition ? hiddenFrontPosition.value : '', updateHandlePosition);
          /* NAYA (2026-09-10): drag band kar diya gaya hai */
          // setupDrag(frontOverlay, saveFrontPosition);
        });
      }

      if (state.selections.back) {
        var bBtn = widget.querySelector('.sc-back-choice[data-sticker-label="' + state.selections.back.label + '"]');
        if (bBtn) bBtn.classList.add('sc-selected');
        goToGallerySlide('back', function () {
          var targetImg = findGalleryImageByAlt('back') || findImageByAltAnyVisibility('back') || findGalleryImage('back');
          var targetWrapper = targetImg ? targetImg.parentElement : null;
          if (!backOverlay || backOverlay.parentElement !== targetWrapper) {
            destroyOverlay(backOverlay);
            backOverlay = createOverlay('back', deleteBackSticker);
          }
          backOverlay.src = state.selections.back.src;
          backOverlay.hidden = false;
          applySavedPosition(backOverlay, hiddenBackPosition ? hiddenBackPosition.value : '', updateHandlePosition);
          /* NAYA (2026-09-10): drag band kar diya gaya hai */
          // setupDrag(backOverlay, saveBackPosition);
        });
      }

      if (state.selections.orderType) {
        var oType = state.selections.orderType === 'Custom Order' ? 'custom' : 'upload';
        var oBtn = widget.querySelector('.sc-order-option[data-order-type="' + oType + '"]');
        if (oBtn) oBtn.classList.add('sc-selected');
      }

      if (state.selections.placement) {
        var pBtn = widget.querySelector('.sc-placement-choice[data-placement="' + state.selections.placement + '"]');
        if (pBtn) pBtn.classList.add('sc-selected');
        showPlacementLogo(state.selections.placement);
      }
    }



        // NAYA: agar customer Shopify mein logged in hai, "Yes/No" step
    // skip karke seedha uska saved logo lookup kar do.
    if (!widget.dataset.scAutoEmailDone) {
      widget.dataset.scAutoEmailDone = 'true';
      // var loggedInEmail = {{ customer.email | json }};
      var loggedInEmail = widget.getAttribute('data-customer-email') || '';
      if (loggedInEmail && isValidEmail(loggedInEmail)) {
        setHidden(hiddenEmail, loggedInEmail);
        if (yesBtn) yesBtn.classList.add('sc-selected');

        var origLabel = findArtworkBtn ? findArtworkBtn.textContent : '';
        if (findArtworkBtn) {
          findArtworkBtn.disabled = true;
          findArtworkBtn.textContent = 'Looking up your artwork...';
        }

        lookupAndApplySavedLogo(loggedInEmail).then(function () {
          if (findArtworkBtn) {
            findArtworkBtn.disabled = false;
            findArtworkBtn.textContent = origLabel;
          }
          showStep(stickersStep);
        });
      }
    }


    restoreState();
  }

  document.querySelectorAll('.sticker-customizer').forEach(initWidget);

  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('sticker-customizer')) {
          initWidget(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.sticker-customizer').forEach(initWidget);
        }
      });
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });
});